// LIBRERIE/IMPORTS
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface LoaderProps {
    agencyData: {
        agency_name: string;
    };
    isLoading: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ agencyData, isLoading }) => {
    const { t } = useTranslation();

    const agencyName = agencyData.agency_name;
    const logoAltText = t('header.navbar.logoAltPattern', { agencyName });
    const logoTitleText = t('header.navbar.logoTitlePattern', { agencyName });
    const homeLinkTitle = t('navigation.homeLinkTitle');

    if (!isLoading) {
        return null;
    }

    return (
        <div>
            <div id="site-loader" className="load-complete">
                <div className="load-position">
                    <div className="logo logo-block">
                        <Link to="/" title={homeLinkTitle ?? 'Home'}>
                            <img
                                src="/assets/images/logo-gold.png"
                                alt={logoAltText}
                                title={logoTitleText}
                            />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Loader;